// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import './Navbar.css';

function Navbar() {
    return (
        <nav className="navbar">
            <div className="navbar-left">
                <Link to="/travel-orb" className="navbar-home-link">
                    <h1>Welcome to Travel Orb</h1>
                </Link>
            </div>
            <div className="navbar-center">
                <ul className="navbar-links">
                    {/* <li>
                        <Link to="/orb">Orb</Link>
                    </li> */}
                    <li>
                        <Link to="/visualization1">International Trips</Link>
                    </li>
                    <li>
                        <Link to="/visualization2">CO₂ emissions</Link>
                    </li>
                    <li>
                        <Link to="/gdp-share">Tourism Economics</Link>
                    </li>
                    <li>
                        <Link to="/visualization4">Air Travel</Link>
                    </li>
                    {/* <li>
                        <Link to="/visualization5">Visualization 5</Link>
                    </li> */}
                    <li>
                        <Link to="/demo">Demo</Link>
                    </li>
                </ul>
            </div>
            <div className="navbar-right">
                <SearchBar />
            </div>
        </nav>
    );
};

export default Navbar;
